exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ribbon-button input{font-size:10px}.ribbon--dropdown{font-size:12px}#modelWat__scrollbar .ribbon--dropdown{padding-top:24px!important}.ol-popup{position:absolute;background-color:#fff;padding:15px;border-radius:10px;border:1px solid #ccc;bottom:12px;left:-50px;width:auto}.ol-popup:after,.ol-popup:before{top:100%;border:solid transparent;content:\" \";height:0;width:0;position:absolute;pointer-events:none}.ol-popup:after{border-top-color:#fff;border-width:10px;left:48px;margin-left:-10px}.ol-popup:before{border-top-color:#ccc;border-width:11px;left:48px;margin-left:-11px}.popup__content>li{width:240px;display:flex;justify-content:space-between}.popup__content>li:not(:last-child){border-bottom:1px solid #d3d3d3}.btnInactive{pointer-events:none!important;background-color:#d3d3d3!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6a430f44","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/viewer/modelWat/ModelWat.vue
// module id = 1671
// module chunks = 0